import * as React from 'react';
import Layout from '@components/layout/Layout';
import Header from '@components/layout/Header';
import Navigation from '@components/layout/Navigation';
import { Outlet } from 'react-router-dom';
import { Announcement } from '@components/dialogs/Announcement';
import { IncorrectUserConfigCheck } from '@components/layout/IncorrectUserConfigCheck';

export default function LoggedInLayout() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  // prevent file drag/drop from navigating the page
  React.useEffect(() => {
    window.addEventListener("dragover",function(e){
      e.preventDefault();
    },false);
    window.addEventListener("drop",function(e){
      e.preventDefault();
    },false);
  }, []);

  return (<>
      {drawerOpen && (
        <Layout.SideDrawer onClose={() => setDrawerOpen(false)}>
          <Navigation drawer={true} />
        </Layout.SideDrawer>
      )}
        <IncorrectUserConfigCheck/>
      <Layout.Root
        sx={{
          ...(drawerOpen && {
            height: '100vh',
            overflow: 'hidden',
          }),
        }}
      >
        <Layout.Header>
          <Header />
        </Layout.Header>
        <Layout.SideNav>
          <Navigation drawer={false} />
        </Layout.SideNav>
        <Layout.Main>
          <Outlet/>
        </Layout.Main>
      </Layout.Root>

      <Announcement/>
  </>);
}
